<template>
  <BrandImage
    v-if="magnoliaGetters.showKioskOrCatalog($flags, mgnlProps.showImageKiosk, mgnlProps.showImageCatalog)"
    :link="link"
    :img="img"
  />
</template>

<script lang="ts" setup>
import BrandImage from '~/components/Footer/Brands/BrandImage/BrandImage.vue';
import { BrandImageBuilder, WrapperProps } from '~/components/Footer/Brands/BrandImage/BrandImage.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = BrandImageBuilder.build(props);

const { $domain } = useNuxtApp();

const img = computed(() => ({
  title: magnoliaGetters.getTitleImage(mgnlProps.image, mgnlProps.title),
  alt: magnoliaGetters.getAltImage(mgnlProps.image, mgnlProps.alt),
  src: magnoliaGetters.getDefaultSrcAsset(mgnlProps.image, $domain.cmsAssetDomainPath),
  srcset: magnoliaGetters.getSrcSetImagesAsString(mgnlProps.image, $domain.cmsAssetDomainPath),
}));

const link = computed(() => magnoliaGetters.getLinkAndName({
  switchable: mgnlProps.switchable,
  linkTargetMode: mgnlProps.linkTargetMode,
  metadata: mgnlProps.metadata,
  title: mgnlProps.title,
}, $domain.cmsAssetDomainPath));
</script>
